import { render } from "./Struktur.vue?vue&type=template&id=4633b9d0"
import script from "./Struktur.vue?vue&type=script&lang=js"
export * from "./Struktur.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__